import CommonBase from '../../settings/util/commonBase';
import AppConstants from '../../../config/app.constants';

class UsersBaseController extends CommonBase {
  /*@ngInject*/
  constructor(Auth, $state, User, Service, Modal, $translate, $stateParams) {

    super(Auth, $state, User, Service, Modal, $translate, $stateParams)

    this.errors = {}
    this.loading = false
    this.autoDetecting = false
    this.errorMessage = ''
    this.model = {};
    this.render = false;
    this.apiKey = '';


    this.customerPermissions = 
      ['service_tickets', 'branch_mgmt', 'branch_mgmt_locations', 'branch_mgmt_items', 'branch_mgmt_orders', 'master_cash_schedule', 'branch_mgmt_cash_transactions', 
       'setting','setting-location', 'branch_mgmt_customer_pickup_reports', 'on_demand_call','pickup_request_management',
       'branch_mgmt_deposit_reports',
       'tnt_react_app',
       // Added permissions for customer users
       'branch_mgmt_daily_balance_sheet',
       'branch_mgmt_cancelled_shipments',
       'branch_mgmt_billing_approval',
       'branch_mgmt_contact_request',
       'branch_mgmt_stop_scheduling',
       'branch_mgmt_bin_manifest',
       'branch_mgmt_average_daily_balance',
       'bulk_cash_management',
       'cash_activity',
       'shipment_batch',
       'ach_management',
       'branch_mgmt_billing_approval_create_billing_record',
       'branch_mgmt_billing_approval_approve_billing_record',
       'branch_mgmt_billing_approval_edit_billing_record',
       'branch_mgmt_billing_approval_delete_billing_record',
       'tnt_billing',
       'tnt_billing_billable_events',
       'tnt_billing_billing_category',
       'tnt_billing_contract',
       'tnt_billing_customer',
       'tnt_billing_location_distance',
       'tnt_billing_fuel_surcharges',
       'price_point',
       'tnt_billing_contract_type'
      ];

    this.states = AppConstants.states;
  }

  resetText() {
    this.model.state = null;
    this.model.country = null;
  }

  askCreate() {
    this.Modal.confirm({
      header: this.$translate.instant('users.create_another_title'),
      message: this.$translate.instant('users.create_another_message'),
      callback: ({
        modal,
        $scope
      }) => {
        this.reset()
        modal.close()
      },
      negative: ({
        modal,
        $scope
      }) => {
        modal.close()
        window.history.go(-1)
      },
      type: 'primary',
      buttons: ['common.yes', 'common.no']
    })
  }
  reset() {
    for (let key in this.model) {
      if (typeof (this.model[key]) == 'string') {
        this.model[key] = ''
      } else if (typeof (this.model[key]) == 'boolean') {
        this.model[key] = false
      }
    }

    this.clearErrors()
  }

  validate() {
    this.clearErrors()
    // for (let key in this.model) {
    //   if (!this.model[key] && typeof (this.model[key]) == 'string') {
    //     this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory')
    //   }
    //}

    return true; //Object.keys(this.errors).length <= 0
  }

  clearErrors() {
    this.errors = {}
    this.errorMessage = ''
  }

  addError(id, message) {
    this.errors[id] = message
  }

  autoDetect() {
    let address = '';

    if (this.model.address) address += this.model.address + ", ";
    if (this.model.city) address += this.model.city + ", ";
    if (this.model.state) address += this.model.state + ", ";
    if (this.model.zip) address += this.model.zip + ", ";
    if (this.model.isNonUSLocation && this.model.country) {
      address += this.model.country;
    } else {
      address += 'US';
    }

    if (!address.trim() || address === 'US') {
      return;
    }

    if (typeof google === 'undefined' || !google.maps || !google.maps.Geocoder) {
      this.Modal.errorModal('Google Maps API is not loaded');
      return;
    }

    this.autoDetecting = true;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'address': address }, (results, status) => {
      this.autoDetecting = false;
      if (status === 'OK' && results && results.length > 0) {
        this.model.lat = results[0].geometry.location.lat();
        this.model.long = results[0].geometry.location.lng();
        if (this.$scope) {
          this.$scope.$apply();
        }
      } else if (status === 'ZERO_RESULTS') {
        this.Modal.errorModal(this.$translate.instant('location.zero_results'));
      } else {
        this.Modal.errorModal(this.$translate.instant('location.invalidAddress'));
      }
    });
  }
}

export default UsersBaseController;



// WEBPACK FOOTER //
// ./client/app/components/users/common/users.base.controller.js